import { timer } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { HttpService } from '../../../globals/providers/http.service';
import { AppEndpoints } from '../../app.endpoints';
import { ICheckUsernameAvailabilityRequest } from '../../classes/existing-onboarding-customer/requests';
import { ICheckUsernameAvailabilityResponse } from '../../classes/existing-onboarding-customer/responses';

export class ExistingOnboardingInfoService {
	public static checkUsernameAvailability(
		request: ICheckUsernameAvailabilityRequest,
		mock = false
	): Observable<ICheckUsernameAvailabilityResponse> {
		if (mock == true) {
			return this.checkUsernameAvailabilityMock(request);
		} else {
			return HttpService.post<ICheckUsernameAvailabilityResponse>(
				AppEndpoints.checkUsernameAvailability,
				request
			);
		}
	}

	private static checkUsernameAvailabilityMock(
		request: ICheckUsernameAvailabilityRequest
	): Observable<ICheckUsernameAvailabilityResponse> {
		let dummyResponse: ICheckUsernameAvailabilityResponse = {
			usernameAvailability: true,
			ibUsername: request.ibUsername,
		};

		return timer(2500).pipe(map(() => dummyResponse));
	}
}
